import { palette, spaces } from '@kimuno/theme';
import { Alert, AlertTitle, Box, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { emailAddresses } from '../../constants';

const PaymentInvoiceContent = () => {
	const { t } = useTranslation();

	return (
		<Box id="invoice_payment" data-testid="invoice-payment-content">
			<Typography variant="body1">{t('Payment by invoice')}</Typography>
			<Alert
				severity="warning"
				variant="outlined"
				sx={{
					borderColor: palette.warning.main,
					color: palette.warning.main,
					paddingX: spaces.md,
					paddingY: spaces.sm,
					marginTop: spaces.lg,
					fontFamily: 'Poppins',
					fontSize: '14px',
					fontStyle: 'normal',
					fontWeight: 300,
					lineHeight: '20px',
					letterSpacing: '0.25px',
				}}
			>
				<AlertTitle
					sx={{
						color: palette.warning.main,
						fontFamily: 'Borna',
						fontSize: '16px',
						fontStyle: 'normal',
						fontWeight: 500,
						lineHeight: '24px',
						letterSpacing: '0.15px',
					}}
				>
					{t('We will be discontinuing this payment method. Please switch to another payment method.')}
				</AlertTitle>
				{t('If you have any questions, please contact our support team via chat or ')}
				<Link href={`mailto:${emailAddresses.support}`} underline="none">
					{emailAddresses.support}
				</Link>
			</Alert>
		</Box>
	);
};

export default PaymentInvoiceContent;
